import React, { useContext, useState } from 'react';
import { Timeout, formattedDate } from '../../functions/functions';
import { FormDoctorContext, ShowDoctorContext } from './types';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import InputsDoctor from './forms/InputsDoctor';
import { useDispatch } from 'react-redux';
import { AddDoctorApi } from '../../redux/doctors/doctorApiCalls';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface props {
  modal: boolean,
  toggle: any
}

const AddDoctorModal:React.FC<props> = ({ modal, toggle }) => {
  const [fullName, setFullName] = useState("")
  const [yearOfBirth, setYearOfBirth] = useState("")
  const [placeOfBirth, setPlaceOfBirth] = useState("")
  const [sex, setSex] = useState("")
  const [telephone, setTelephone] = useState("")
  const [whatsapp, setWhatsapp] = useState("")
  const [email, setEmail] = useState("")
  const [current, setCurrent] = useState("")
  const [origin, setOrigin] = useState("")
  const [medecinType, setMedecinType] = useState<any>(null)
  const [inscriptionDate, setInscriptionDate] = useState(formattedDate(new Date().toString()))
  const [avatar, setAvatar] = useState<File | any>(null)
  const [password, setPassword] = useState("1234")
  const [speciality, setSpeciality] = useState("")
  const [cabinet, setCabinet] = useState<any>({  })

  const [loading, setLoading] = useState(false)

  const dispatch: any = useDispatch()

  const { setShowSuccessMsg } = useContext(ShowDoctorContext)
  const [errors, setErrors] = useState<string[]>([])


  const handleSubmit = async (e: any) => {
    e.preventDefault()
    try {
      setLoading(true)

      const formData = new FormData()
      formData.append("cabinet", cabinet.value)
      formData.append("fullName", fullName)
      formData.append("yearOfBirth", yearOfBirth)
      formData.append("placeOfBirth", placeOfBirth)
      formData.append("sex", sex)
      formData.append("contact", JSON.stringify({
        phone: telephone,
        whatsapp,
        email
      }))
      formData.append("nationality", JSON.stringify({
        current,
        origin,
      }))
      formData.append("medecinType", medecinType)
      formData.append("inscriptionDate", inscriptionDate)
      formData.append("avatar", avatar)
      formData.append("password", password)
      formData.append("speciality", speciality)
      
      const response: any = await dispatch(AddDoctorApi(formData))
      if(response === true) {
        toggle()
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout) 
        setErrors([])
        setFullName("")
        setYearOfBirth("")
        setPlaceOfBirth("")
        setSex("")
        setTelephone("")
        setWhatsapp("")
        setEmail("")
        setCurrent("")
        setOrigin("")
        setInscriptionDate("")
        setAvatar(null)
        setPassword("")
        setSpeciality("")
        setCabinet({ })
      } else {
        setErrors(response)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormDoctorContext.Provider value={{
      fullName, setFullName,
      yearOfBirth, setYearOfBirth,
      placeOfBirth, setPlaceOfBirth,
      sex, setSex,
      telephone, setTelephone,
      whatsapp, setWhatsapp,
      email, setEmail,
      current, setCurrent,
      medecinType, setMedecinType,
      origin, setOrigin,
      inscriptionDate, setInscriptionDate,
      avatar, setAvatar,
      password, setPassword,
      speciality, setSpeciality,
      cabinet, setCabinet,
    }}>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full p-4 mx-auto bg-white rounded-md shadow-lg" style={{ width: "800px" }}>
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <InputsDoctor />
                    <ButtonsForm loading={loading} typeBtn='Ajouter' toggle={toggle}/>
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </FormDoctorContext.Provider>
  );
}

export default AddDoctorModal

